import * as signalR from "@microsoft/signalr";
import appConstants from "../appConstants";
import Events from "../utilities/EventEmitter";
import { datadogLogs } from "@datadog/browser-logs";

class SignalRClient {
  constructor() {
    this.connection = null;
    this.terminalConnection = null;
  }
  startConnection = () => {
    this.connection
      .start()
      .then(() => {
        console.log("Connection Started ");
        this.addUsersToGroups();
      })
      .catch((err) => {
        console.log("Error connecting to Notifications service ", err);
        setTimeout(() => this.startConnection(), 5000);
      });
  };
  addUsersToGroups = () => {
    this.connection
      .invoke("addUserToGroup", this.tenantId, this.scenarioId)
      .catch((err) =>
        console.error("Error while adding users to group ", err.toString())
      );
    this.connection
      .invoke("adduserToTerminalGroup", this.tenantId, this.terminalCode)
      .catch((err) =>
        console.error(
          "Error while adding users to terminal group ",
          err.toString()
        )
      );
    console.log("Client Connected");
  };
  connectToHub = (scenario, terminal) => {
    let domainMatch = window.location.hostname.match(/^([a-zA-Z0-9]+)\.?/i);
    this.tenantId =
      domainMatch && domainMatch.length >= 2 ? domainMatch[1] : "";
    this.scenarioId = scenario;
    this.terminalCode = terminal;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("/notifications")
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();
    this.startConnection();

    //Dynamic Routing
    this.connection.on(
      "dynamicRoutingCompleted",
      (scenarioId, affectedRoutes, lastWaveRoutes, extraTrailerRoutes) => {
        console.log("Dynamic Routing Completed for scenario: ", scenarioId);
        Events.emit(
          "RoutingStatus",
          scenarioId,
          true,
          affectedRoutes,
          lastWaveRoutes,
          extraTrailerRoutes
        );
      }
    );
    this.connection.on("dynamicRoutingFailed", (scenarioId) => {
      Events.emit("RoutingStatus", scenarioId, false);
    });
    this.connection.on("routingProgress", (scenarioId, percentCompleted) => {
      console.log(
        "Routing Progress for scenario id: ",
        scenarioId,
        percentCompleted
      );
      Events.emit(
        "RoutingStatus",
        scenarioId,
        true,
        null,
        null,
        null,
        percentCompleted
      );
    });

    //Route Publish
    this.connection.on("routePublishCompleted", (scenarioId, terminalCode) => {
      console.log("Routes data published for scenario: ", scenarioId);
      Events.emit("RoutePublishCompleted", scenarioId, terminalCode, true);
    });
    this.connection.on("routePublishFailed", (scenarioId, terminalCode) => {
      console.log("Routes data publish failed for scenario: ", scenarioId);
      Events.emit("RoutePublishCompleted", scenarioId, terminalCode, false);
    });

    //ETL
    this.connection.on(
      "etlStarted",
      (scenarioId, terminalCode, isFirstPush, planDate) => {
        console.log(
          "ETL running for scenario: ",
          scenarioId,
          terminalCode,
          isFirstPush,
          planDate
        );
        Events.emit(
          "ETLProgress",
          "started",
          scenarioId,
          terminalCode,
          false,
          isFirstPush,
          planDate
        );
      }
    );
    this.connection.on(
      "etlCompleted",
      (scenarioId, terminalCode, isFirstPush, planDate) => {
        console.log(
          "ETL completed for scenario: ",
          scenarioId,
          terminalCode,
          isFirstPush,
          planDate
        );
        Events.emit(
          "ETLProgress",
          "completed",
          scenarioId,
          terminalCode,
          true,
          isFirstPush,
          planDate
        );
      }
    );

    this.connection.on(
      "etlFailed",
      (scenarioId, terminalCode, isFirstPush, planDate) => {
        console.log(
          "ETL failed for scenario: ",
          scenarioId,
          terminalCode,
          isFirstPush,
          planDate
        );
        Events.emit(
          "ETLProgress",
          "completed",
          scenarioId,
          terminalCode,
          false,
          isFirstPush,
          planDate
        );
      }
    );
    //Dispatch
    this.connection.on("dispatchCancelled", (terminalCode, dataString) => {
      console.log("dispatchCancelled completed");
        const data = JSON.parse(dataString);
      Events.emit("RefreshDispatchStore",{
        eventName: "dispatchCancelled",
        driverIds:[data.driverId],
      });
    });
    this.connection.on("pickupAssigned", (terminalCode, data) => {
      console.log("pickupAssigned completed");
      Events.emit(
        "HandlePickupEvent",
        data,
        appConstants.PICKUP_EVENTS.ASSIGN_PICKUP
      );
    });
    this.connection.on("pickupUnassigned", (terminalCode, data) => {
      console.log("pickupUnassigned completed");
      Events.emit(
        "HandlePickupEvent",
        data,
        appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP
      );
    });
    this.connection.on("driverAssigned", (terminalCode, dataString) => {
      console.log("DriverAssigned completed");
        const data = JSON.parse(dataString);
      Events.emit("RefreshDispatchStore",{
        driverIds: [data.driverId],
      });
    });
    this.connection.on("driverRouteUpdated", (terminalCode, dataString) => {
      console.log("Update from DriverApp");
      const data = JSON.parse(dataString);
      switch (data.eventType) {
        case "StopsCompleted":
          Events.emit("DeliveryCompleted", data);
          break;
        case "NextStopChanged":
          if (data.isDispatcherUpdatedSequence) {
            Events.emit("NextStopChanged", data);
          }
          break;
        case "EndOfTrip":
          Events.emit("EndOfTripCompleted", data);
          break;
        case "PickupCompleted":
        case "NoFreightPickedUp":
        case "AddProToCompletedPickup":
          Events.emit("PickupCompleted", data);
          break;
      }
      Events.emit("UpdateDriverRoute", data.driverId);
    });
    this.connection.on("proAdded", (terminalCode, dataString) => {
      console.log("Add Pro Completed");
      const data = JSON.parse(dataString);
      if (data.success) {
        Events.emit("UpdateDriverRoute", data.driverId);
      }
      Events.emit("proAdded", data);
    });
    this.connection.on("trailerHooked", (_terminalCode, dataString) => {
      console.log("Trailer Hooked");
      const data = JSON.parse(dataString);
      if (data.success) {
        Events.emit("UpdateDriverRoute", data.driverId);
        Events.emit("UpdateSpottedTrailers");
      }
      Events.emit("trailerHooked", data);
    });
    this.connection.on("trailerDropped", (_terminalCode, dataString) => {
      console.log("Trailer Dropped");
      const data = JSON.parse(dataString);
      if (data.success) {
        Events.emit("UpdateDriverRoute", data.driverId);
        Events.emit("UpdateSpottedTrailers");
      }
      Events.emit("trailerDropped", data);
    });
    this.connection.on("bobtailProcessed", (_terminalCode, dataString) => {
      console.log("bobtail Processed");
      const data = JSON.parse(dataString);
      if (data.success) {
        Events.emit("UpdateDriverRoute", data.driverId);
      }
      Events.emit("bobtailProcessed", data);
    });
    this.connection.on("moveBillsProcessed", (terminalCode, dataString) => {
      console.log("Move Bills processed");
      const data = JSON.parse(dataString);
      if (data.success) {
        const driverIdList =  [data.driverId]; // bills moved from driver
        if (data?.toDriver) {
          driverIdList.push(data.toDriver) //bills moved to driver
        }
        Events.emit("UpdateDriverRoute", driverIdList);
      }
      Events.emit("MoveBills", data);
    });
    this.connection.on("dispatchUpdate", (terminalCode, dataString) => {
      console.log("UpdateStop Completed ");

      Events.emit("RefreshEquipmentData");      
      const data = JSON.parse(dataString);
      Events.emit("RefreshDispatchStore",{
        driverIds: [data.driverId],
      });
      if (data.eventType === "EquipmentDefectUpdated") {
        Events.emit("EquipmentDefectsUpdated", data);
      }
      if (data.eventType === "EndOfTrip") {
        Events.emit("EndOfTripCompleted", data);
      }
    });
    this.connection.on("proDeleted", (terminalCode, dataString) => {
      console.log("Delete Pro Completed");
      const data = JSON.parse(dataString);
      if (data.success) {
        Events.emit("UpdateDriverRoute", data.driverId);
      }
      Events.emit("proDeleted", data);
    });
    this.connection.on("plannedKPIUpdated", (terminalCode) => {
      Events.emit("refreshDispatchKPI");
    });
    this.connection.on("pickupUpdated", (terminalCode, dataString) => {
      //handle createPickup and updatePickup events
      console.log("Pickup Updated completed ");
      const data = JSON.parse(dataString);
      if (data?.driverId) {
        Events.emit("UpdateDriverRoute", data.driverId, false);
      } else {
        Events.emit("RefreshPickupsData", true);
      }
      if (data.eventType === "ChangePickupTerminal") {
        Events.emit("showPickupTerminalChangeMessage", data);
      } else if(data.eventType === "VoidPickup") {
        Events.emit("VoidPickup", data);
      }
    });
    this.connection.on(
      "duplicatePickupsDetected",
      (...data) => {
        datadogLogs.logger.info("Event duplicatePickupsDetected received on signalR", data);
        Events.emit("RefreshDuplicatePickups");
      }
    );
    this.connection.on(
      "locationUpdated",
      (terminalCode, driverId, latitude, longitude, eventTime) => {
        console.log("Driver Location Updated");
        Events.emit(
          "AddDriverLocation",
          terminalCode,
          driverId,
          latitude,
          longitude,
          eventTime
        );
      }
    );
    this.connection.on("messageFromDriver", (terminalCode, data) => {
      console.log("Message From Driver");
      Events.emit("MessageFromDriver", data);
    });

    this.connection.on("messageRead", (terminalCode, data) => {
      console.log("Driver Read dispatcher message");
      Events.emit("DispatcherMessageRead", data);
    });

    this.connection.on("driverLoginStatusUpdate", (terminalCode, data) => {
      console.log("Driver logged in status updated");
      Events.emit("UpdateDriverLoginStatus", data);
    });

    // As we are enabling automatic reconnects we don't need this
    // this.connection.onclose(()=>{
    //     console.log("Connection Closed");
    //     this.connection.start();
    // });
    this.connection.serverTimeoutInMilliseconds = 7200000;

    this.connection.onreconnecting((error) => {
      console.assert(
        this.connection.state === signalR.HubConnectionState.Reconnecting,
        "Error while reconnecting"
      );
      console.log(error);
    });

    // Notifications
    this.connection.on("notificationUpdated", () => {
      Events.emit("UpdateNotifications");
    });

    //Dispatch
    this.connection.on("driverDispatched", (terminalCode, dataString) => {
      console.log("DriverDispatch completed");
      const data = JSON.parse(dataString);
      Events.emit("RefreshDispatchStore", {
        driverIds: [data.driverId],
      });
      Events.emit("DriverDispatched", data);
    });

    this.connection.on("stopMoved", (eventTerminalCode, eventData) => {
      console.log("Stop Sequence Changed");
      Events.emit("stopMoved", eventData);
    });

    this.connection.on("trailerStatusUpdated", () => {
      console.log("Trailer data updated");
      Events.emit("RefreshTrailersData");
      Events.emit("UpdateSpottedTrailers");
    });

    this.connection.on("pickupAcknowledged", (terminalCode, data) => {
      console.log("Pickup acknowledged");
      Events.emit("UpdatePickupAcknowledgedStatus", data);
    });

    this.connection.on("pickupsMerged", (terminalCode, dataString) => {
      console.log("Pickups merged");
      const data = JSON.parse(dataString);
      Events.emit("MergePickups", data);
      if (data.success) {
        data.driverId && Events.emit("UpdateDriverRoute", data.driverId);
        Events.emit("RefreshPickupsData", true);
      }
    });

    this.connection.on("shipmentDetected", (terminalCode , planDate) => {
      console.log("New Shipments Detected");
      Events.emit("NewShipmentsDetected", terminalCode, planDate);
    });
    // As we are enabling automatic reconnects we don't need this
    // this.connection.onclose(()=>{
    //     console.log("Connection Closed");
    //     this.connection.start();
    // });
    this.connection.serverTimeoutInMilliseconds = 7200000;

    this.connection.onreconnecting((error) => {
      console.assert(
        this.connection.state === signalR.HubConnectionState.Reconnecting,
        "Error while reconnecting"
      );
      console.log(error);
    });

    this.connection.onreconnected((connectionId) => {
      console.assert(
        this.connection.state === signalR.HubConnectionState.Connected,
        "Error while reconnecting"
      );
      if (this.connection.state === signalR.HubConnectionState.Connected) {
        this.addUsersToGroups();
      }
    });
  };

  disconnectFromHub = () => {
    if (this.connection) {
      return this.connection.stop();
    } else return Promise.resolve();
  };
}
export default new SignalRClient();
